import React, { useState } from 'react';
import { Form, Button, Select, Input, Tooltip, Space, } from 'antd';
import { SearchOutlined, WarningFilled } from '@ant-design/icons';
import { GroupedDevicesTable } from '../GroupedDevicesTable.component';

const { Option } = Select;

export const VLAN = ({ data, vlans, saveChanges, isPanelPending, renderEditableCellValue, ...props}) => {

    const [currentDevice, setCurrentDevice] = useState();

    const renderVlanOptions = (vlans) => {
        const sortedVlans = vlans?.sort((a, b) => a.tag.localeCompare(b.tag));
        return sortedVlans?.map(vlan => <Option key={vlan.id} value={vlan.vlanID}>{vlan.tag}</Option> );
    };

    const renderVLANTag = (id) => {
        let vlanEl = vlans?.find((vlan) => vlan.vlanID === id);
        
        if(vlanEl){
            return vlanEl.tag;
        }
    }

    const columns = [
        {
            title: 'Device Name',
            dataIndex: 'comment',
            key: 'comment',
            editable: true,
            render: (value, record) => {
                return (
                    <>
                    { isPanelPending(record) ? 
                        <Space>
                            <Tooltip title='Displaying pending changes'>
                                <WarningFilled style={{color: 'var(--warning-color)'}}/>
                            </Tooltip>
                            {renderEditableCellValue(value, record, 'comment')}
                        </Space> 
                    :
                        <p>{value}</p>
                    }
                    </>
                )
            }
        },
        {
            title: 'MAC Address',
            dataIndex: 'macAddr',
            key: 'macAddr',
        },
        {
            title: 'VLAN',
            dataIndex: 'vlanID',
            key: 'vlanID',
            render: (vlan) => {
                return (
                    <p>{renderVLANTag(vlan)}</p>
                );
            },
        },
        {
            title: 'Action',
            dataIndex: 'action',
            key: 'action',
            render: (_, record) => {
                return (
                    <Button 
                        type="primary" 
                        icon={<SearchOutlined/>}
                        >
                        IP/Location
                    </Button>
                );
            },
        },
    ];

    const formItems = (
        <>
            <Form.Item label='Description:' name='comment'  >
                <Input/>
            </Form.Item>
            <Form.Item label='MAC Address:' name='macAddr'>
                <Input disabled/>
            </Form.Item>
            <Form.Item label='VLAN:' name='vlanID'>
                <Select disabled={true}>
                    {renderVlanOptions(vlans)}
                </Select>
            </Form.Item>
        </>
    );

    return (
        <>
            <GroupedDevicesTable
                editable={false}
                serialNum={false}
                columns={columns}
                dataSource={data || []}
                formItems={formItems}
                isPanelPending={isPanelPending}
                saveChanges={saveChanges}
                currentDevice={currentDevice}
                setCurrentDevice={setCurrentDevice}
            />
        </>
    );
}